import { get } from '../index';

export const getSettingsBySettingId = (settingId) => {
  return get(`/model-health-settings/${settingId}`);
};
